import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Global from './mixins/global.js'
import Helpers from './mixins/helpers.js'
import xhrModule from './modules/xhrModule.js'
import globalErrorHandler from './modules/globalErrorHandler.js'

Vue.config.productionTip = false

Vue.mixin(Global)
Vue.mixin(Helpers)

// log all JS errors in DB
globalErrorHandler.init()

// check if we are logged in or not
var url = '/cms/api/session'
xhrModule.get(url, function (data) {
	data = data.data
	changePageTitle(data.project.name)

	if (data.user.username !== 'unauthenticated') {
		// user exists
		var user = data.user
		user['privileges'] = data.privileges
		user['project'] = data.project
		store.dispatch('setAuth', user)
	}

	store.dispatch('setFreshdeskId', data.project.freshdesk_id)

	startApp()
})

function startApp () {
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
}

function changePageTitle (changePageTitle) {
	const title = document.querySelector('title')
	title.innerHTML = process.env.VUE_APP_TITLE + changePageTitle
}
